export default __webpack_public_path__ + "static/media/362.18ff1b56.png";